import {createWebHistory} from "vue-router"
import {createRouter} from "vue-router"
import Login from './views/Login.vue'
import Sso from './views/Sso.vue'
import NewMessage from './views/NewMessage.vue'
import MessageView from './views/MessageView.vue'
import Main from './layouts/Main.vue'
import Home from './views/Home.vue'
import Dashboard from './views/Dashboard.vue'
import useAuthStore from "@/stores/auth.store.js";

const routes = [
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {guest: true}
  },
  {
    path: "/sso",
    name: "sso",
    component: Sso,
    meta: {guest: true}
  },
  {
    path: "/password/forgot",
    name: "ask_password_forgot",
    component: () => import('./views/Auth/PasswordForgot.vue'),
    meta: {guest: true}
  },
  {
    path: "/password/reset/:token",
    name: "password_reset",
    component: () => import('./views/Auth/PasswordReset.vue'),
    meta: {guest: true}
  },{
    path: "/messages/new",
    name: "new_message",
    component: NewMessage
  }, {
    path: "/account/:account/message/:message",
    name: "message",
    component: MessageView
  },{
    path: "",
    component: Main,
    children: [
      {
        path: "",
        name: "home",
        component: Home,
        meta: {sidebar: "home"}
      },
      {
        path: "/dashboard/:company",
        name: "dashboard",
        component: Dashboard,
        meta: {sidebar: "company"}
      },
      {
        path: "/account/:account",
        children: [
          {
            path: "messages/:folder",
            name: "messages",
            // Here it is necessary to do a dynamic import to avoid
            // premature loading of the BootstrapTable library, which
            // would brake the app.
            component: () => import("./views/FolderMessages.vue"),
            meta: {sidebar: "company"}
          },
          {
            path: "tag/:tag",
            name: "tag_messages",
            // Same as for the 'messages' route
            component: () => import("./views/TagMessages.vue"),
            meta: {sidebar: "company"}
          },
          {
            path: "contacts",
            name: "contacts",
            component: () => import("./views/Contacts.vue"),
            meta: {sidebar: "company"}
          },
          {
            path: "address-books",
            name: "address-books",
            component: () => import("./views/AddressBooks.vue"),
            meta: {sidebar: "company"}
          },
        ]
      },
      // {
      //   path: "/account/:account/draft",
      //   name: "draft",
      //   component: () => import("./views/Draft.vue"),
      //   meta: {sidebar: "company"}
      // },
      {
        path: "/admin",
        name: "admin_dashboard",
        component: () => import('@/views/Admin/Dashboard.vue'),
        meta: {sidebar: "admin"}
      },
      {
        path: "/admin/company",
        name: "admin_company",
        component: () => import('@/views/Admin/Company.vue'),
        meta: {sidebar: "admin"}
      },
      {
        path: "/admin/group",
        name: "admin_group",
        component: () => import('@/views/Admin/Group.vue'),
        meta: {sidebar: "admin"}
      },
      {
        path: "/admin/account",
        // name: "account",
        component: () => import('@/views/Admin/Account.vue'),
        meta: {sidebar: "admin"}
      },
      {
        path: "/admin/user",
        // name: "messages",
        component: () => import('@/views/Admin/User.vue'),
        meta: {sidebar: "admin"}
      },
      {
        path: "/admin/oauthapp",
        // name: "messages",
        component: () => import('@/views/Admin/OauthApp.vue'),
        meta: {sidebar: "admin"}
      },
      {
        path: "/admin/retention",
        component: () => import('@/views/Admin/Retention.vue'),
        meta: {sidebar: "admin"}
      },
      {
        path: "/admin/logs",
        component: () => import('@/views/Admin/Log.vue'),
        meta: {sidebar: "admin"}
      },
      {
        path: "/admin/stats",
        component: () => import('@/views/Admin/Stats.vue'),
        meta: {sidebar: "admin"}
      }
    ]
  },
]


const router = createRouter({
  history: createWebHistory(),
  linkExactActiveClass: "active",
  scrollBehavior: () => ({y: 0}),
  routes: routes,
})

router.beforeEach((to, from, next) => {
  const auth = useAuthStore()
  if (!to.meta.guest) {
    if (!auth.authenticated) {
      next({name: "login"})
    } else {
      next()
    }
  } else {
    if (auth.authenticated && to.name === "login") {
      next({name: "home"})
    } else {
      next()
    }
  }
})
export default router
